import * as React from "react";
import { TitleSectionFormRegistration } from "../../../FormRegistration/components/TitleSection";
import TextInputFormRegistration from "../../../FormRegistration/components/TextInput/TextInput";
import { useRegistrationFormDance } from "../../../../../store/user";
import { useNavigate, useParams } from "react-router-dom";
import classNames from "classnames";
import {
  checkFilledData,
  getStringSafely,
  handleIsRequired,
  validateEmail,
} from "../../../FormRegistration/utils";

interface Props {
  isLoading: boolean;
  setStep: (step: number) => void;
}

const StepDataAkun: React.FC<Props> = ({ isLoading = false, setStep }) => {
  const navigate = useNavigate();

  const { category, city, mode } = useParams();
  const { dataAccount, errorAccount, setDataAccount, setErrorAccount } =
    useRegistrationFormDance();

  const isEditMode = mode === "edit";
  const isButtonDisabled = isEditMode
    ? false
    : validateEmail(dataAccount?.email ?? "") ||
      getStringSafely(dataAccount?.password)?.length < 8;

  const handleChangeInput = (value: string, name: string) => {
    setErrorAccount({ ...errorAccount, [name]: "" });
    setDataAccount({ ...dataAccount, [name]: value });
  };

  const handleNextStep = () => {
    if (!isEditMode) {
      if (
        checkFilledData(dataAccount) >= 2 &&
        !validateEmail(dataAccount?.email ?? "")
      ) {
        return setStep(1);
      }

      setErrorAccount({
        email: validateEmail(dataAccount?.email ?? ""),
        password: handleIsRequired(dataAccount?.password ?? ""),
      });
      return;
    }

    return setStep(1);
  };

  const handleBlur = (_, error: string, name: string) => {
    setErrorAccount({ ...errorAccount, [name]: error });
  };

  const handleBackStep = () => {
    let url = isEditMode ? "/" : !!city ? `/${city}/registrasi` : "/registrasi";

    navigate(url, { state: { city, category } });
  };

  return (
    <div className="h-auto">
      <TitleSectionFormRegistration
        title="Masukan Informasi Akun"
        category={String(category).toUpperCase()}
        chipColor="#F48120"
        chipText="Dance"
        isDance
      />

      <div className="flex flex-col gap-y-[8px]">
        <TextInputFormRegistration
          label="Email"
          name="email"
          isRequired
          value={dataAccount?.email ?? ""}
          placeholder="emailkamu@gmail.com"
          errorMessage={errorAccount?.email ?? ""}
          type="email"
          validation={["email"]}
          checkingValidationType="onTyping"
          onChangeValue={handleChangeInput}
          disabled={isEditMode}
          onBlur={handleBlur}
        />
        <TextInputFormRegistration
          label="Password"
          name="password"
          isRequired
          value={isEditMode ? "your_password" : dataAccount?.password ?? ""}
          placeholder="Masukin password"
          errorMessage={errorAccount?.password ?? ""}
          validation={["password"]}
          type="password"
          checkingValidationType="onTyping"
          onChangeValue={handleChangeInput}
          disabled={isEditMode}
          onBlur={handleBlur}
        />
      </div>

      <div className="w-full max-w-[600px] flex px-[24px] py-[16px] gap-x-[16px]">
        <button
          disabled={isLoading}
          onClick={handleBackStep}
          className="rounded-[32px] border-[1px] border-[#1F2D3D] py-[12px] px-[16px] text-[16px] text-[#1F2D3D] leading-none font-semibold w-[50%]"
        >
          Kembali
        </button>
        <button
          disabled={isLoading}
          onClick={handleNextStep}
          className={classNames(
            "rounded-[32px] bg-[#00BCF1] py-[12px] px-[16px] text-[16px] leading-none font-semibold w-[50%] text-white",
            {
              "bg-[#00BCF1]": !isButtonDisabled,
              "bg-slate-300": isButtonDisabled,
            }
          )}
        >
          Lanjut
        </button>
      </div>
    </div>
  );
};

export default StepDataAkun;
